import "./style.css";
import ReactMarkdown from "react-markdown";

function UserChatComponent({ chat }) {
  let showText = "";
  if (
    typeof chat?.content === "object" &&
    chat?.content !== null &&
    !Array.isArray(chat?.content)
  ) {
    if ((chat.content.type = "initiateRelationship")) {
      showText = chat?.content?.text;
    }
  } else {
    showText = chat?.content;
  }
  return (
    <div
      className={`user-chat-container ${
        chat?.type === "element" && " user-chat-container-element"
      }`}
    >
      {chat?.type === "showAsListInUserChat" &&
      typeof chat?.content !== "string" ? (
        <>
          {chat?.hearderQuest && <p style={{ display: "flex" }}>{chat?.hearderQuest}</p>}
          <ul style={{ display: "flex", flexDirection: "column" }}>
            {" "}
            {chat?.content?.map((_l) => (
              <li key={_l}>{_l}</li>
            ))}
          </ul>
        </>
      ) : typeof chat?.content === "object" &&
        chat?.content?.type === "initiateRelationship" ? (
        <div>
          <div>{chat?.content?.text}</div>
          <div className="chat-initiateRelationship-img-cntr">
            {chat?.content?.profile_pic_url ? (
              <img
                src={chat?.content?.profile_pic_url}
                alt={chat?.content?.name}
                className="chat-in-small-pic"
              />
            ) : (
              <div className="chat-contacts-initial-insider">
                {chat?.content?.name?.charAt(0)}
              </div>
            )}

            {chat?.content?.name}
          </div>
        </div>
      ) : chat?.type === "element" ? (
        <div>
          <ReactMarkdown
            components={{
              h1: "h3",
              h2: "h4",
            }}
          >
            {chat?.content}
          </ReactMarkdown>
        </div>
      ) : (
        <>
          {chat?.hearderQuest && <b>{chat?.hearderQuest}</b>}
          <div> {chat?.content}</div>
        </>
      )}
    </div>
  );
}

export default UserChatComponent;
